import React, {useState, createContext, useContext, useEffect} from "react";
import tariffData from "../data/tariffData.json";

interface TariffContextType {
    selectedTariffId: string | null;
    setSelectedTariffId: (id: string) => void;
}

const TariffContext = createContext<TariffContextType | undefined>(undefined);

export const TariffProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [selectedTariffId, setSelectedTariffId] = useState<string | null>(null);

    useEffect(() => {
        // Предустанавливаем значение selectedTariffId на id из JSON
        const defaultTariffId = tariffData.length > 0 ? String(tariffData[0].id) : null;
        setSelectedTariffId(defaultTariffId);
    }, []);

    return (
        <TariffContext.Provider value={{selectedTariffId, setSelectedTariffId}}>
            {children}
        </TariffContext.Provider>
    );
}

export const useTariff = (): TariffContextType => {
    const context = useContext(TariffContext);
    if (!context) {
        throw new Error("useTariff must be used within a TariffProvider");
    }
    return context;
};